import { render, staticRenderFns } from "./fbs.vue?vue&type=template&id=0eb96771&scoped=true&"
import script from "./fbs.vue?vue&type=script&lang=js&"
export * from "./fbs.vue?vue&type=script&lang=js&"
import style0 from "./fbs.vue?vue&type=style&index=0&id=0eb96771&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb96771",
  null
  
)

export default component.exports